"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSingleEditableCell = exports.IsSingleEditableCellTableInstance = void 0;
const React = __importStar(require("react"));
const text_submit_1 = require("../text-submit");
const EditableCell = ({ value: initialValue, cell }) => {
    if (IsEditableCell(cell)) {
        const onSubmit = (newValue) => {
            cell.UpdateValue(newValue);
            cell.FinishEditing();
        };
        const onCancel = () => {
            cell.FinishEditing();
        };
        return cell.IsEditing
            ? React.createElement(text_submit_1.TextSubmit, { InitialValue: initialValue, OnSubmit: onSubmit, OnCancel: onCancel, Autofocus: "End" })
            : React.createElement("span", null, initialValue);
    }
    else {
        return React.createElement("span", null, initialValue);
    }
};
function IsEditableColumn(column) {
    return !!column.GetUpdater;
}
function IsEditableCell(cell) {
    return !!cell.FinishEditing;
}
function IsSingleEditableCellTableOptions(instance) {
    const propName = "editCell";
    return propName in instance;
}
function IsSingleEditableCellTableInstance(instance) {
    return !!instance.StartEditingCell;
}
exports.IsSingleEditableCellTableInstance = IsSingleEditableCellTableInstance;
/** Allows one cell at a time to be edited in place.
 * @description A cell may only be edited if its column has an UpdateValue() method (see EditableColumn type)
  */
function useSingleEditableCell(hooks) {
    const [editingCellPosition, setEditingCellPosition] = React.useState(null);
    const finishEditing = (cell, tableInstance) => {
        if (editingCellPosition
            && editingCellPosition.column === cell.column.id
            && editingCellPosition.row === cell.row.id) {
            setEditingCellPosition(null);
            if (IsSingleEditableCellTableOptions(tableInstance)) {
                tableInstance.cancelEdit();
            }
        }
    };
    hooks.columns.push(columns => {
        for (const column of columns) {
            if (IsEditableColumn(column)) {
                const columnWithCell = column;
                if (columnWithCell.Cell) {
                    throw new Error("Editing column with custom Cell renderer is not currently supported.");
                }
                columnWithCell.Cell = EditableCell;
            }
        }
        return columns;
    });
    hooks.prepareRow.push((row, { instance }) => {
        if (editingCellPosition && editingCellPosition.row === row.id) {
            const editingCell = row.cells.find(cell => cell.column.id === editingCellPosition.column);
            let updateCell;
            // Check this particular cell is editable
            if (editingCell && IsEditableColumn(editingCell.column) && (updateCell = editingCell.column.GetUpdater(row))) {
                const editOptions = {
                    UpdateValue: updateCell,
                    IsEditing: true,
                    FinishEditing: () => finishEditing(editingCell, instance)
                };
                Object.assign(editingCell, editOptions);
            }
        }
    });
    hooks.useInstance.push(instance => {
        if (IsSingleEditableCellTableOptions(instance)) {
            let singleEditableCellOptions = {
                StartEditingCell: setEditingCellPosition,
                ActiveCell: editingCellPosition
            };
            if (!editingCellPosition && instance.editCell) {
                const col = instance.columns.find(column => column.Header === instance.editCell.ColumnName);
                setEditingCellPosition({ row: instance.editCell.RowId, column: col.id });
            }
            Object.assign(instance, singleEditableCellOptions);
        }
    });
}
exports.useSingleEditableCell = useSingleEditableCell;
//# sourceMappingURL=editable-cell.js.map